var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site-layout"},[_c('site-header',{staticClass:"site-layout__header"}),_c('main',{staticClass:"site-layout__content"},[_vm._t("default")],2),_c('site-footer',{staticClass:"site-layout__footer"}),_c('reference-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }